const SCREEN_SIZES = {
  TABLET: 768,
  MOBILE: 500,
};

export { SCREEN_SIZES };
